import { Text } from "@clipboard-health/ui-components";
import { ButtonBase, Stack } from "@mui/material";

import { DOUBLE_FOOTER_BACKGROUND_COLOR, DOUBLE_FOOTER_TEXT_COLOR } from "./constants";
import { ShiftDoublePill } from "./Pill";

interface ShiftDoubleFooterProps {
  companionCount?: number;
  onClick?: () => void;
}

export function ShiftDoubleFooter(props: ShiftDoubleFooterProps) {
  const { companionCount = 1, onClick } = props;

  const label = companionCount > 1 ? `${companionCount} doubles available` : "View double \u2192";

  return (
    <ButtonBase
      sx={{
        width: "100%",
        textAlign: "left",
        display: "block",
        backgroundColor: DOUBLE_FOOTER_BACKGROUND_COLOR,
        borderBottomLeftRadius: "inherit",
        borderBottomRightRadius: "inherit",
      }}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ paddingX: 5, paddingY: 4 }}
      >
        <ShiftDoublePill />
        <Text
          semibold
          variant="body2"
          sx={{
            color: DOUBLE_FOOTER_TEXT_COLOR,
          }}
        >
          {label}
        </Text>
      </Stack>
    </ButtonBase>
  );
}
